/*
 * Public API Surface of ngx-mat-tag-input
 */


export * from './lib/ngx-mat-tag-input.component';
export * from './lib/ngx-mat-tag-input.module';
